<hs-panel-card
  class="d-flex flex-column w-100 h-100"
  header="Job Selection Expected"
>
  <p>{{ message }}</p>
</hs-panel-card>
